import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import * as _moment from 'moment';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';
import { ReportData } from './ReportData';
// import { setInterval, clearInterval} from 'timers';


@Component({
    selector: 'app-report-listing',
    templateUrl: './report-listing.component.html',
    styleUrls: ['./report-listing.component.css'],
    standalone: false
})

export class ReportListingComponent implements OnInit {
  display = 'none';
  url: string;
  ModuleData: any;
  pageurl: string;
  ReportID: string;
  TypeHeader: string;
  advanceSearchValue: any;
  CallFunctionOnCloseModal: any;
  ModelFor: string;
  modalURL: any;
  Level: number;
  AdditionalFilter: string;
  RptType: number;
  Flow: string;
  DownloadURL: string;
  varInterval: any;
  pageLoaded: boolean;
  MasterMenu: any;
  MasterMenu1: any;
  Param: string;
  FilterValue: string;
  FilterFlow: string;
  MsgType: any;
  DisplayMessage: string;
  Status: any;
  RadioValue: any;
  showBackButton = false;
  printedBy = localStorage.getItem('UserName');
  printedByEmail = localStorage.getItem('email');
  printedDate = new Date().toLocaleString();

  constructor(private router: Router, private http: HttpClient, private sanitization: DomSanitizer) {
    this.url = AppComponent.baseURL;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && this.advanceSearchValue != undefined && this.advanceSearchValue != null) {
        this.pageurl = this.router.url;
        let pagehead = this.pageurl.split('/');
        this.ReportID = pagehead[2];
        this.Level = Number(pagehead[3]);
        this.RptType = Number(pagehead[4]);
        this.AdditionalFilter = pagehead[5];
        this.Flow = pagehead[6];
        this.Param = pagehead[7];
        if (pagehead[1] != "report") {
          this.pageLoaded = false;
        }
        if (pagehead[1] == "report" && this.pageLoaded != undefined && this.pageLoaded == true) {

          this.BuildFilterParam(this.Param);
          this.FetchReport();
        }
      }
    });
  }


  ngOnInit() {
    this.MasterMenu = 1;
    this.MasterMenu1 = 1;
    this.pageLoaded = true;
    this.advanceSearchValue = null;
    this.DownloadURL = AppComponent.DownloadURL;
    this.TypeHeader = "Loading Report ...";
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ReportID = pagehead[2];
    this.Level = Number(pagehead[3]);
    this.RptType = Number(pagehead[4]);
    this.showBackButton = window.history.length > 1;

    this.AdditionalFilter = pagehead[5];
    this.Flow = pagehead[6];
    this.Param = pagehead[7];
    let Statusdata = this.Param.split('~');
    this.Status = Statusdata[1];
    this.advanceSearchValue = { Flow: this.Flow };
    this.BuildFilterParam(this.Param);
    this.FetchReport();
    let element: HTMLElement;
    element = document.getElementsByClassName('modal-backdrop')[0] as HTMLElement;
    if (element != null) {
      element.remove();
    }
  }

  print() {
    // document.getElementById('HideSubMenu').style.display = "none";
    // document.getElementById('MasterMenu').style.display = "none";
    // document.getElementById('MasterMenuDivider').style.display = "none";
    // document.getElementById('MasterMenuHeader').style.display = "none";
    // document.getElementById('navbar').classList.add('hide');
    // document.getElementById('sidebar').classList.add('hide');
    // var printContents = document.getElementById('PrintPage').innerHTML;
    // var originalContents = document.body.innerHTML;
    window.print();
    // setTimeout(function () {
      // document.getElementById('HideSubMenu').style.display = "block";
      // document.getElementById('MasterMenu').style.display = "block";
      // document.getElementById('MasterMenuDivider').style.display = "block";
      // document.getElementById('MasterMenuHeader').style.display = "block";
      // document.getElementById('navbar').classList.remove('hide');
      // document.getElementById('sidebar').classList.remove('hide');
    // }, 1000);
  }

printReport(orientation: 'portrait' | 'landscape' = 'portrait') {

  const isLandscape = orientation === 'landscape';

  const printWindow = window.open('', '_blank');

  const htmlContent = `
  <html>
  <head>
    <title>Print</title>

    <style>

      @page {
        size: ${isLandscape ? 'A4 landscape' : 'A4 portrait'};
        margin: 10px;
      }

      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        -webkit-print-color-adjust: exact;
      }

      table.print-layout {
        width: 100%;
        border-collapse: collapse;
        position: relative;
        z-index: 2;
      }

      thead { display: table-header-group; }
      tfoot { display: table-footer-group; }

      /* HEADER */
      .header-table td {
        border-bottom: 2px solid #000;
        padding: 8px;
        vertical-align: middle;
      }

      .header-left img {
        height: 50px;
      }

      .header-center {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }

      .header-right {
        text-align: right;
        font-size: 12px;
      }

      /* FOOTER */
      .footer-table td {
        border-top: 1px solid #000;
        text-align: center;
        font-size: 10px;
        padding: 5px;
      }
       /*.footer-table{
        bottom: 0;
        position: fixed;
      } */

      .content-cell {
        padding: 10px;
      }

      tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
      }

      a{
        text-decoration: none;
        color: black;
      }
      .listing td,.listing th {
        border: 1px solid #000 !important;
        white-space: normal;
        word-wrap: break-word;
        font-size: 12px;
        /*  word-break: break-all; */
      }

      .table-wrapper {
        width: 100%;
        overflow: visible;
      }

      table th:nth-child(n+13),
      table td:nth-child(n+13) {
        display: none !important;
      }

      @media print {
        body { counter-reset: page; }

        .pageNumber::after {
          content: counter(page);
        }
      }
    </style>
  </head>

  <body>
    <table class="print-layout">

      <!-- HEADER -->
      <thead>
        <tr>
          <td class="scale-container">
            <table class="header-table" width="100%">
              <tr>
                <td width="20%" class="header-left">
                  <img src="assets/images/logo-praticaone.png">
                </td>

                <td width="60%" class="header-center">
                  Legal Management System
                </td>

                <td width="20%" class="header-right">
                  <div><strong>Printed By:</strong> ${this.printedBy}</div>
                  <div>${this.printedByEmail}</div>
                  <div>${this.printedDate}</div> 
                </td>
              </tr>
            </table>
            <div class="table-heading" style="text-align: center; font-size: 20px; font-weight: bold;" >
                ${this.TypeHeader}
            </div>
          </td>
        </tr>
      </thead>

      <!-- FOOTER -->
      <!-- <tfoot>
        <tr>
          <td>
            <table class="footer-table" width="100%">
              <tr>
                <td>
                  Page <span class="pageNumber"></span> of <span class="totalPages"></span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </tfoot> -->

      <!-- CONTENT -->
      <tbody>
        <tr>
          <td class="content-cell"  >
            <div class="scale-container">
              <div class="table-wrapper">
                ${this.ModuleData}
              </div>
            </div>

          </td>
        </tr>
      </tbody>

    </table>

    <script>

      function addPageNumbers() {
        const totalPages = Math.ceil(document.body.scrollHeight / window.innerHeight);
        document.querySelectorAll('.totalPages').forEach(el => el.textContent = totalPages);
      }

      window.onload = function() {
        addPageNumbers();
        window.print();
        window.onafterprint = () => window.close();
      };

    </script>

  </body>
  </html>
  `;

  printWindow.document.open();
  printWindow.document.write(htmlContent);
  printWindow.document.close();
}
  public get HtmlData(): SafeHtml {
    return this.sanitization.bypassSecurityTrustHtml(this.ModuleData);
  }

  FetchReport() {

    this.http.post(this.url + 'Report/GetReport', {
      ReportID: this.ReportID,
      Param: this.advanceSearchValue,
      Level: this.Level,
      AdditionalFIlter: this.AdditionalFilter,
      RptType: this.RptType,
      Mode: 0
    }
    )
      .subscribe((data: ReportData) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "";//"No Data Found";
          this.ModuleData = null;
        } else {
          this.MsgType = 0; // No Message
          this.ModuleData = data.Data;
          this.TypeHeader = data.Heading;
        }
      },
        (error) => {
          this.MsgType = 3; // Error Message
          //  this.DisplayMessage = error.message;
        }
      );
  }
  OpenModal(url, cID, modelName, urld) {
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      window.addEventListener("message", this.receiveMessage, false);
      this.modalURL = "filter/" + this.ReportID + "~" + this.Flow + "~" + this.Status;
    }
    if (modelName == "Column Selection") {
      this.modalURL = "reportcolumn/" + this.ReportID + "/1/0";
    }
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null){
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch'));

      this.FilterValue = this.advanceSearchValue["Flow"];
      localStorage.setItem('advancesearch', "");

      if (this.FilterValue != this.Flow) {
        if (this.FilterValue == undefined) {
          this.FetchReport();
        }
        else { window.location.href = "report/" + this.ReportID + "/0/0/0/" + this.FilterValue + "/0"; }
      }
      else { this.FetchReport(); }
      //
    }

  }
  ReturnColumnSelect() {
    this.FetchReport();
  }
  setTag(obj: any, isChecked: boolean) {
  }
  DownloadReport(Mode) {
    var newWindow = window.open();
    newWindow.document.write('Downloading ...');
    this.http.post(this.url + 'Report/DownloadReport', {
      ReportID: this.ReportID,
      Param: this.advanceSearchValue,
      Level: this.Level,
      AdditionalFIlter: this.AdditionalFilter,
      Mode: Mode,
      RptType: this.RptType
    }
    )
      .subscribe((data) => {
        newWindow.location.href = this.DownloadURL + data;
        if(Mode.toString() !="9")
        {
          this.varInterval = setInterval(() => {
            if (newWindow.document.readyState == 'complete') {
              newWindow.close();
              clearInterval(this.varInterval);
            }
          }, 200);
       }
      }
      );
  }
  BuildFilterParam(Param) {
    if (Param == "0")
      return;
    let jsonString: string = '';
    let arr2;
    Param = Param.replace(/%7C/g, '|');
    let arr = Param.split('|');
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == '')
        continue;
      arr2 = arr[i].split('~');
      if (arr2[0].substring(0, 3) == 'HLP') {
        jsonString += (jsonString != '' ? ',' : '') + '\"' + arr2[0] + '\"' + ":[" + arr2[1] + "]";
      }
      else {
        jsonString += (jsonString != '' ? ',' : '') + '\"' + arr2[0] + '\"' + ":\"" + arr2[1] + "\"";
      }
    }
    jsonString += (jsonString != '' ? ',' : '') + '\"Flow\"' + ":\"" + this.Flow + "\"";
    this.advanceSearchValue = JSON.parse("{" + jsonString + "}");

  }

  onItemChange(value){
     this.router.navigate(['/report/207084000/0/0/0/32/HLPNoticeType~'+ value+'']);
   

}
  goBack(){
    window.history.back();
  }
}

